import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';

export default class extends Controller {
    static targets = ['next', 'previous'];

    static values = {
        slidesPerView: Object,
        autoplay: {type: Boolean, default: false}
    }

    connect() {
        if (this.hasSlidesPerViewValue === false) {
            this.slidesPerViewValue = {'576': 1, '768': 2, '992': 3, '1200': 4};
        }

        let configuration = {
            loop: false,
            spaceBetween: 20,
            breakpoints: {
                576: {
                    slidesPerView: this.slidesPerViewValue['576'],
                },
                768: {
                    slidesPerView: this.slidesPerViewValue['768'],
                },
                992: {
                    slidesPerView: this.slidesPerViewValue['992'],
                },
                1200: {
                    slidesPerView: this.slidesPerViewValue['1200'],
                }
            },
            navigation: {
                nextEl: this.hasNextTarget ? this.nextTarget : ".swiper-button-next",
                prevEl: this.hasPreviousTarget ? this.previousTarget : ".swiper-button-prev",
            },
            modules: [Navigation, Autoplay],
        };

        if (this.autoplayValue === true) {
            configuration['autoplay'] = {
                delay: 3500,
                disableOnInteraction: false,
            };
        }

        this.swiper = new Swiper(this.element, configuration);
    }
}